




















































































import { defineComponent, reactive, toRefs, onMounted } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import moment from 'moment';
import AlertArea from "../../components/AlertArea.vue";
import { SearchCondition, User } from "../../modules/teacher/BulkSendMail"

export interface Data {
  condition: SearchCondition
  users: User[]
  isAllChecked: boolean
  title: string
  mailText: string
  errors: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(prop, context){

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      condition: new SearchCondition(),
      users: new Array<User>(),
      title: "",
      mailText: "",
      isAllChecked: false,
      errors: new Array<string>(),
    });

    /******************************
     * 最終アクセス日を画面表示文言にコンバート
     ******************************/

    const convertLastAccessAt = (lastAccessAt: string) => {
      return lastAccessAt ? moment(lastAccessAt).format('Y年M月D日') : "-";
    };

    const checkAll = (value: boolean) => {
      state.users.forEach(x => x.isSelected = value);
    };

    /******************************
     * 検索条件初期化
     ******************************/

    const clearCondition = () => {
      state.condition = new SearchCondition();
    };

    /******************************
     * 検索
     ******************************/

    const search = async () => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/teacher/bulk_send_mail?${Common.BuildQuery(state.condition, 'search_condition')}`).then(response => {
        state.users = response.data.users.map((x: any) => new User(x));
        state.isAllChecked = false;
        state.errors = [];
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * メール送信API
     ******************************/

    const sendMail = async () => {

      if(state.title == ""){
        alert("件名を入力してください。");
        return;
      }

      if(state.mailText == ""){
        alert("メール本文を入力してください。");
        return;
      }

      if(state.users.filter(x => x.isSelected).length == 0){
        alert("送信対象の教師を選択してください。");
        return;
      }

      if (!window.confirm('メールを一括送信します。よろしいですか？')) {
        return;
      }

      const emails = state.users.filter(x => x.isSelected).map(x => x.email);
      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/bulk_send_mail/send_mail`, {emails: emails, title: state.title, mail_text: state.mailText}).then(response => {
        alert("処理が完了しました。");
        window.history.back();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * リリースメール送信API
     ******************************/

    const sendReleaseMail = async () => {

      if(state.title == ""){
        alert("件名を入力してください。");
        return;
      }

      if(state.mailText == ""){
        alert("メール本文を入力してください。");
        return;
      }

      if (!window.confirm('リリースのメールを一括送信します。よろしいですか？')) {
        return;
      }

      const emails: string[] = [
        "kina_n@cscinfo.co.jp",
        "super_2251@yahoo.co.jp"
      ];

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/bulk_send_mail/send_mail`, {emails: emails, title: state.title, mail_text: state.mailText}).then(response => {
        alert("処理が完了しました。");
        window.history.back();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      
    });

    return {
      ...toRefs(state),
      convertLastAccessAt,
      checkAll,
      clearCondition,
      sendMail,
      search,
      sendReleaseMail,
    }
  }
})
